module.exports = __webpack_public_path__ + "img/plusfl_1.e0179a92.png";